import APITemplate from '@api/APITemplate'
import con from '@services/connection'
import { formatQueryParams } from '@utils/Format'
import { RUNS, RUN_DETAIL } from '@modules/ai-framework/constants/URL'

const ERRO_INESPERADO = 'Erro inesperado. Tente novamente mais tarde.'

// Execuções & Auditoria (spec-004, grupo B) — 100% READ-ONLY. Nenhum método muta run/step.
// Envelope { status, message, value } de response.data — status lido pelo caller.
class APIAiFrameworkRuns extends APITemplate {
  // GET /runs — lista paginada, tenant-locked, escopo gestor/autor server-side.
  async list({ idInstance, idProfissional, canal, status, de, ate, limit, offset } = {}) {
    const params = formatQueryParams({
      id_instance: idInstance,
      id_profissional: idProfissional,
      canal: canal,
      status: status,
      de: de,
      ate: ate,
      limit: limit,
      offset: offset,
    })
    const r = await con.get(RUNS + params)
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }

  // GET /runs/:id_run — timeline (steps) + decisão vinculada. 404 opaco cross-tenant.
  async detail(idRun) {
    if (idRun === undefined || idRun === null || idRun === '') {
      return { status: 400, message: 'id_run obrigatório', value: null }
    }
    const r = await con.get(RUN_DETAIL(idRun))
    return r || this.buildErrorResponse({ message: ERRO_INESPERADO })
  }
}

// Singleton no padrão do projeto: instância nomeada + export explícito.
// A classe NÃO é exportada — ninguém a consome (verificado por grep em src/),
// e export sem consumidor é código morto que o próximo leitor tenta preservar.
const apiAiFrameworkRuns = new APIAiFrameworkRuns()

export { apiAiFrameworkRuns }
